//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.StructureDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/SelectTaggedObjectList.js";
import "../no/Section.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../Features/Features.StructureDesign.FeatureSpreadsheetBuilder.js";
import "../Features/Features.StructureDesign.HandrailYOffsetBuilder.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[0,"BMergePaths",1,0],[0,"BPreserveLen",1,0],[0,"BRevStanchionDir",1,0],[0,"BReversePaths",1,0],[1,"CornerRadius",0,"Expression",0],[0,"CornerType",1,0],[1,"DatumOffset",0,"Expression",0],[1,"EndLimit",0,"Expression",0],[0,"FileName",1,0],[0,"HandrailType",1,0],[1,"PlaceDatums",0,"SelectTaggedObjectList",0],[1,"SelectedCurves",0,"Section",0],[0,"StanchionPositionType",1,0],[1,"StartLimit",0,"Expression",0],[0,"StartPointOnLoop",1,0],[1,"StartPointOnLoopDim",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"StockData",0,"Features.StructureDesign.FeatureSpreadsheetBuilder",0],[1,"XOffset",0,"Expression",0],[1,"YOffset",0,"Features.StructureDesign.HandrailYOffsetBuilder",0]],[[[],"UpdateSegmentsData",{},0,0],[[],"ApplyPathXOffset",{},0,0],[[],"ReorderPathsBeforeLimit",{},0,0],[[],"SpecifyStartPointOnClosedLoop",{},0,0],[[],"ApplyBendAtCorner",{},0,0]],[]];
SPLM.Features.StructureDesign.HandrailBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StructureDesign.HandrailBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StructureDesign.HandrailBuilder.HandrailTypes = Object.freeze({
    "Linear" : "Linear", "Curved" : "Curved"});

SPLM.Features.StructureDesign.HandrailBuilder.CornerTypes = Object.freeze({
    "None" : "None", "Bend" : "Bend"});

SPLM.Features.StructureDesign.HandrailBuilder.StanchionPositionTypes = Object.freeze({
    "Gap" : "Gap", "Datum" : "Datum"});

export default SPLM;